import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDWriteOff(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdWriteOff(period),
    queryFn: () => dashboardApi.getMDWriteOff(period),
  });
}
